import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import { Round as ArrowForwardIosIcon } from '@tamagoshi/icons/ArrowForwardIos';

export default function ChevronRight({ className, ...props }) {
    const [isClient, setIsClient] = useState(false);
    useEffect(() => {
        setIsClient(true);
    }, []);
    return isClient && <ArrowForwardIosIcon {...props} className={className} />;
}

ChevronRight.propTypes = {
    className: string,
};

ChevronRight.defaultProps = {
    className: null,
};
